import { BreakpointManager } from '@volue/wave';
import { useEffect, useState } from 'react';

export type BreakPoint = 'small' | 'medium' | 'large' | 'xlarge';
type BreakPointCallback = (breakPoint: BreakPoint) => any;
type OnChangeBreakPoint = (
  change: 'change',
  callback: BreakPointCallback
) => void;
type BreakpointManagerType = {
  start: () => void;
  stop: () => void;
  getCurrent: () => BreakPoint;
  on: OnChangeBreakPoint;
  off: OnChangeBreakPoint;
};

let breakPointManager: BreakpointManagerType;

function useBreakPointManager() {
  if (!breakPointManager) {
    breakPointManager = BreakpointManager() as BreakpointManagerType;
    breakPointManager.start();
  }
  return breakPointManager;
}

export function useBreakPoint() {
  const manager = useBreakPointManager();
  const [breakPoint, setBrakePoint] = useState<BreakPoint>(
    breakPointManager.getCurrent()
  );

  useEffect(() => {
    const onNewBreakPoint = (newBreakPoint: BreakPoint) => {
      setBrakePoint(newBreakPoint);
    };
    manager.on('change', onNewBreakPoint);
    return () => {
      manager.off('change', onNewBreakPoint);
    };
  }, [manager]);

  return breakPoint;
}
